import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.substring(1) : hash);
    const sessionId = params.get('session_id');

    (async () => {
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch {
        navigate('/', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <div className="flex gap-2">
        <div className="ss-dot" />
        <div className="ss-dot" />
        <div className="ss-dot" />
      </div>
    </div>
  );
};
